export const TwitterIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_191_27207)">
      <circle
        cx="20.5555"
        cy="20"
        r="20"
        fill="#16304A"
      />
      <path
        d="M32.4555 12.3689C31.6933 12.7138 30.8508 12.9231 30.028 13.0613C30.419 12.9955 30.9916 12.2886 31.222 12.0029C31.5735 11.5672 31.8631 11.0709 32.0277 10.5338C32.0487 10.4917 32.0645 10.439 32.0224 10.4074C31.9697 10.3863 31.9355 10.3969 31.8934 10.4179C30.9758 10.9103 30.0254 11.267 29.0157 11.5185C28.9314 11.5395 28.8695 11.5185 28.8169 11.4658C28.7326 11.371 28.655 11.2828 28.5654 11.2091C28.1402 10.8471 27.6848 10.5641 27.1713 10.3547C26.4973 10.0796 25.7601 9.96377 25.0335 10.0098C24.3265 10.0559 23.6328 10.2547 23.0048 10.5825C22.3756 10.9116 21.8148 11.3684 21.3685 11.9187C20.9065 12.4887 20.5655 13.1627 20.3917 13.8762C20.2232 14.5647 20.2377 15.2466 20.3404 15.943C20.3562 16.0588 20.3457 16.0746 20.2417 16.0588C16.2884 15.4704 13.0118 14.0565 10.3526 11.0261C10.2368 10.8945 10.1749 10.8945 10.0801 11.0367C8.91642 12.7809 9.48117 15.5836 10.9345 16.9606C11.128 17.1449 11.3281 17.3279 11.5427 17.4951C11.465 17.5109 10.4975 17.4069 9.63519 16.9606C9.51934 16.8882 9.46142 16.929 9.45221 17.0606C9.44167 17.2489 9.45747 17.4227 9.4838 17.6267C9.70759 19.3947 10.9319 21.031 12.609 21.6681C12.8078 21.7524 13.0276 21.8261 13.2435 21.8617C12.8618 21.9459 12.4681 22.0051 11.3716 21.9196C11.2347 21.8932 11.1833 21.9617 11.2347 22.092C12.0574 24.3365 13.8359 25.004 15.1668 25.3844C15.3445 25.416 15.5236 25.416 15.7026 25.4568C15.6921 25.4726 15.6815 25.4726 15.671 25.4884C15.23 26.1611 13.699 26.6627 12.9855 26.9115C11.6888 27.3643 10.2776 27.5684 8.9072 27.4328C8.68736 27.4012 8.64129 27.4025 8.58205 27.4328C8.52149 27.4696 8.57415 27.5223 8.64523 27.5789C8.923 27.7619 9.20603 27.9251 9.49433 28.0831C10.3645 28.5438 11.2715 28.9111 12.2207 29.1731C17.1204 30.5264 22.6389 29.5325 26.317 25.8768C29.2052 23.0069 30.2176 19.0484 30.2176 15.086C30.2176 14.9307 30.4005 14.8451 30.5098 14.7635C31.2615 14.1987 31.8671 13.5234 32.4278 12.7691C32.5542 12.5993 32.5555 12.4492 32.5555 12.3873V12.3662C32.5555 12.3031 32.5555 12.3215 32.4568 12.3662L32.4555 12.3689Z"
        fill="#1888ED"
      />
    </g>
    <defs>
      <clipPath id="clip0_191_27207">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.555542)"
        />
      </clipPath>
    </defs>
  </svg>
);
